<template>
  <section>
    <v-row class="my-5 text-center">
      <v-col cols="12" class="mt-3 mb-5">
        <h2 class="mt-10 mb-2 pretopia-head-font pretopia-display-1">
          {{ $t('home.mainInfoBoxes.title') }}
        </h2>
        <span class="title">
          {{ $t('home.mainInfoBoxes.content') }}
        </span>
      </v-col>
    </v-row>

    <v-container grid-list-xl>
      <v-row>
        <v-col cols="12" md="4">
          <v-card class="elevation-0 transparent">
            <v-card-text class="text-center pb-0">
              <img class="slutare" src="/images/pretopia_symb_fylld_pms4535.png" />
            </v-card-text>
            <v-card-title primary-title class="layout justify-center">
              <div class="wrapper primary py-2">
                <div
                  class="text-center white--text text-uppercase word-break-normal pretopia-head-font pretopia-title-1"
                >
                  {{ $t('home.mainInfoBoxes.boxTitle1') }}
                </div>
              </div>
            </v-card-title>
            <v-card-text class="subtitle-1 pretopia-lighten-text">
              {{ $t('home.mainInfoBoxes.boxContent1') }}
              <br />
              <a href="#" @click.prevent="$emit('signup-vendor-click')">{{ $t('home.mainInfoBoxes.boxContentLinkText1') }}</a>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="elevation-0 transparent">
            <v-card-text class="text-center pb-0">
              <img class="slutare" src="/images/pretopia_symb_fylld_pms4535.png" />
            </v-card-text>
            <v-card-title primary-title class="layout justify-center">
              <div class="wrapper primary py-2">
                <div
                  class="word-break-normal text-center white--text text-uppercase pretopia-head-font pretopia-title-1"
                >
                {{ $t('home.mainInfoBoxes.boxTitle2') }}
                </div>
              </div>
            </v-card-title>
            <v-card-text class="subtitle-1 pretopia-lighten-text">
              {{ $t('home.mainInfoBoxes.boxContent2') }}
              <br />
              <a href="mailto:info@pretopia.se">{{ $t('home.mainInfoBoxes.boxContentLinkText2') }}</a>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="elevation-0 transparent">
            <v-card-text class="text-center pb-0">
              <img class="slutare" src="/images/pretopia_symb_fylld_pms4535.png" />
            </v-card-text>
            <v-card-title primary-title class="layout justify-center">
              <div class="wrapper primary py-2">
                <div
                  class="word-break-normal text-center white--text text-uppercase pretopia-head-font pretopia-title-1"
                >
                  {{ $t('home.mainInfoBoxes.boxTitle3') }}
                </div>
              </div>
            </v-card-title>
            <v-card-text class="subtitle-1 pretopia-lighten-text">
              {{ $t('home.mainInfoBoxes.boxContent3') }}<br />
              <a href="#" @click.prevent="$emit('signup-click')">{{ $t('home.mainInfoBoxes.boxContentLinkText3') }}</a>
              {{ $t('home.mainInfoBoxes.boxContentLinkText4') }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  emits: ['signup-click', 'signup-vendor-click'],
};
</script>

<style lang="scss">
.word-break-normal {
  word-break: normal;
}

.slutare {
  width: 70px;
}
</style>
